import styled from 'styled-components'

export const Root = styled.div`
  background: ${(props) => props.theme.palette.default.greyLight};
  padding-top: ${(props) => props.theme.padding.big};
  padding-bottom: ${(props) => props.theme.padding.big};
`
